import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen, FilterBox} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Display,Button,Line,Card,DataGrid,IDataGridLayout} from 'ktm-ui';

interface IdsPolicyHolders {
    Id:string;
    Name:string;
    DBA:string;
    MailingCity:string;
    MailingProv:string;
};

export default KTMScreen({name:"planadmin.lookups.policy-holder"}, class extends React.Component<{keyword?:string,eventValue?:string}> {

    data:{
        dsPolicyHolders:IdsPolicyHolders;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsPolicyHolders";
        await KTMApi.start(screen,{
            "@keyword":this.props.keyword
        });
        screen.onEnterKey = this.search;
        screen.title = "Policy holder lookup";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout  dialogSize="medium" dialogHeight="medium" padding="none">
                {draw(this.header)}
                {draw(this.search_panel)}
                {draw(this.default_view)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Account holder lookup">
            </Dialog.Header>
        );
    }

    search_panel({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Line>
                    <FilterBox field={field("@keyword")} />
                    <Button action={action(this.search)} label="Search" style="primary"/>
                </Line>
            </Card>
        );
    }

    default_view({field,draw,action,collection}:RenderEvent){
        let actions = null;
        let layout:IDataGridLayout = {
            columns:[
                {name:"Name",label:"Name",type:"character",width:250},
                {name:"DBA",label:"DBA",type:"character",width:250},
                {name:"MailingCity",label:"Mailing City",type:"character"},
                {name:"MailingProv",label:"Mailing Prov",type:"character"},
            ],
            sort:[{name:"Name"}]
        };
        return (
            <DataGrid collection={collection("@dsPolicyHolders")} layout={layout} actions={actions} onRowClick={action(this.on_row_click)}/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
            </Dialog.Footer>
        );
    }

    async search({screen}:ActionEvent){
        await KTMApi.action(screen,"search",{
            "@keyword":screen.getFilter('@keyword')
        });
    }

    async on_row_click({screen}:ActionEvent){
        screen.close({continue:true,value:screen.getValue("Id"),label:screen.getValue("Name")});
    }

});
